import moment from "moment";
import {Injectable} from '@angular/core';
import {Adapter} from '@secca/shared/interfaces/adapter';
import {DateSerializer} from '@secca/shared/models/date-serializer';
import {ICCSplitInvoiceStatus} from "@secca/shared/models/enums";
import {ICCSplitInvoiceItem, ICCSplitInvoiceItemAdapter} from "@secca/shared/models/ICCInvoiceSplit/i-c-c-split-invoice-item";
import {Currency} from "dinero.js";

export class ICCSplitInvoice {
  id: number;
  caseId: number;
  supplierInvoiceId: number;
  crediting: number;
  exchangeRate: number;
  supplierInvoiceCurrency: Currency;
  status: ICCSplitInvoiceStatus;
  iccSplitInvoiceItems: ICCSplitInvoiceItem[];
  modifiedBy: string;
  modifiedOn: moment.Moment;
  deletedBy: string;
  deletedOn: moment.Moment;
  revision: number

  public constructor(init?: Partial<ICCSplitInvoice>) {
    Object.assign(this, init);
  }

  isValid():boolean{
    return this.caseId !== null &&
      this.supplierInvoiceId !== null &&
      this.exchangeRate !== null &&
      this.supplierInvoiceCurrency !== null &&
      this.iccSplitInvoiceItems &&
      this.iccSplitInvoiceItems.every(item => item.isValid());
  }
  getTotal(): number {
    return this.iccSplitInvoiceItems.map(item => item.splitOriginalInvoiceMoney.amount).reduce((sum, current) => sum + current, 0);
  }
  getTotalDKK(): number {
    return this.iccSplitInvoiceItems.map(item => item.splitMoney.amount).reduce((sum, current) => sum + current, 0);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ICCSplitInvoiceAdapter implements Adapter<ICCSplitInvoice> {
  constructor(private iccSplitInvoiceItemAdapter: ICCSplitInvoiceItemAdapter) {
  }
  adapt(item: any): ICCSplitInvoice {
    return new ICCSplitInvoice({
      id: item.id,
      caseId: item.caseId,
      supplierInvoiceId: item.supplierInvoiceId,
      crediting: item.crediting,
      exchangeRate: item.exchangeRate,
      supplierInvoiceCurrency: item.supplierInvoiceCurrency,
      status: item.status,
      iccSplitInvoiceItems: item.iccSplitInvoiceItems ? item.iccSplitInvoiceItems.map(line => this.iccSplitInvoiceItemAdapter.adapt(line, item.exchangeRate, item.supplierInvoiceCurrency)) : [],
      modifiedBy: item.modifiedBy,
      modifiedOn: item.modifiedOn ? DateSerializer.deserialize(item.modifiedOn) : null,
      deletedBy: item.deletedBy,
      deletedOn: item.deletedOn ? DateSerializer.deserialize(item.deletedOn) : null,
      revision: item.revision
    });
  }
}
